import '../../styles/restScreens.css';
import { useEffect, useState } from 'react';
import { supabaseClient } from '../../config/supabase';

function ContactBillingPreferences({ contact }) {
    const [preferences, setPreferences] = useState({ autopay_enabled: false });
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState('');

    useEffect(() => {
        let active = true;
        const loadPreferences = async () => {
            try {
                const { data, error } = await supabaseClient
                    .from('contacts')
                    .select('payment_preferences')
                    .eq('id', contact.id)
                    .eq('org_id', contact.org_id)
                    .maybeSingle();
                if (!active) return;
                if (error) {
                    setMessage('Billing preferences could not be loaded.');
                } else {
                    setPreferences({
                        ...(data?.payment_preferences || {}),
                        autopay_enabled: data?.payment_preferences?.autopay_enabled === true,
                    });
                }
                setLoading(false);
            } catch {
                if (!active) return;
                setMessage('Billing preferences could not be loaded.');
                setLoading(false);
            }
        };
        loadPreferences();
        return () => { active = false; };
    }, [contact.id, contact.org_id]);

    const updateAutopay = async (enabled) => {
        if (saving || loading) return;
        setSaving(true);
        setMessage('');
        const next = { ...preferences, autopay_enabled: enabled };
        try {
            const { data, error } = await supabaseClient
                .from('contacts')
                .update({ payment_preferences: next })
                .eq('id', contact.id)
                .eq('org_id', contact.org_id)
                .select('id')
                .maybeSingle();
            if (error) throw error;
            if (!data) throw new Error('Contact billing preferences were not updated.');
            setPreferences(next);
            setMessage('Billing preferences updated.');
        } catch {
            setMessage('Billing preferences could not be saved.');
        } finally {
            setSaving(false);
        }
    };

    return (
        <section data-m6-layout="clients" data-m6-component="ContactBillingPreferences" className="rounded-lg border border-[var(--surface-border)] p-4" aria-label="Billing preferences">
            <h3 className="text-sm font-semibold text-[var(--ink)]">Preferences · Billing</h3>
            <label htmlFor={`contact-autopay-${contact.id}`} className="mt-3 flex items-start gap-2 text-xs text-[var(--ink)]">
                <input
                    id={`contact-autopay-${contact.id}`}
                    type="checkbox"
                    checked={preferences.autopay_enabled}
                    disabled={loading || saving}
                    onChange={(event) => updateAutopay(event.target.checked)}
                />
                <span>Autopay enabled</span>
            </label>
            <p className="mt-2 text-[11px] text-[var(--ink-muted)]">
                When enabled, Thank You messages may include the payment receipt. Otherwise they include the invoice link.
            </p>
            {message && <p className="mt-2 text-xs text-[var(--ink)]" role="status">{message}</p>}
        </section>
    );
}

export default ContactBillingPreferences;
